import { theme } from './theme';

export const buttonDark = {
  backgroundColor: theme.palette.common.darkGrey2,
  color: theme.palette.common.lightGrey6,
  width: 'fit-content',
  minWidth: 'fit-content',
  fontWeight: 600,
  borderRadius: '40px',
  border: '3px transparent solid',
  '&:hover': {
    backgroundColor: theme.palette.common.darkBlue2
  },
  '&[disabled]': {
    color: theme.palette.common.darkGrey8,
    backgroundColor: theme.palette.common.lightGrey9,
    borderColor: 'transparent'
  },
  '&:focus': {
    border: '3px solid  #4FA8FF'
  }
};

export const buttonPrimary = {
  backgroundColor: theme.palette.common.darkPink,
  color: theme.palette.common.white,
  fontWeight: 600,
  borderRadius: '40px',
  border: '3px transparent solid',
  '&:hover': {
    backgroundColor: theme.palette.common.brandPrimary60
  },
  '&:focus': {
    outline: `3px ${theme.palette.common.darkPink} solid`,
    outlineOffset: '5px'
  },
  '&:active': {
    backgroundColor: theme.palette.common.brandPrimary70
  },
  '&.Mui-disabled, &[disabled]': {
    backgroundColor: theme.palette.common.monochrome15,
    color: theme.palette.common.monochrome50
  }
};

export const buttonPrimaryV2 = {
  backgroundColor: theme.palette.common.buttonPrimaryDefault,
  color: theme.palette.common.white,
  fontWeight: 600,
  borderRadius: '40px',
  border: '3px transparent solid',
  '&:hover': {
    backgroundColor: theme.palette.common.buttonPrimaryHover
  },
  '&:focus': {
    outline: `3px ${theme.palette.common.buttonPrimaryDefault} solid`,
    outlineOffset: '5px'
  },
  '&:active': {
    backgroundColor: theme.palette.common.buttonPrimaryPressed
  },
  '&.Mui-disabled, &[disabled]': {
    backgroundColor: theme.palette.common.monochrome15,
    color: theme.palette.common.monochrome50
  }
};

export const buttonQuaternary = {
  color: theme.palette.common.primaryDark,
  backgroundColor: 'transparent',
  borderColor: theme.palette.common.lightGrey11,
  fontWeight: 600,
  borderRadius: '40px',
  border: '3px solid transparent',
  '&:hover': {
    backgroundColor: theme.palette.common.lightGrey9
  },
  '&:focus': {
    outline: `3px ${theme.palette.common.darkPink} solid`,
    outlineOffset: '5px'
  },
  '&:active': {
    backgroundColor: theme.palette.common.lightGrey3
  },
  '&.Mui-disabled, &[disabled]': {
    backgroundColor: theme.palette.common.monochrome15,
    color: theme.palette.common.monochrome50
  }
};

export const buttonOutlineDark = {
  color: theme.palette.common.primaryDark,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.common.lightGrey14}`,
  padding: '8px 16px',
  fontSize: '16px',
  lineHeight: '24px',
  borderRadius: '80px',
  '&:hover': {
    backgroundColor: theme.palette.common.monochrome15
  },
  '&[disabled]': {
    color: theme.palette.common.monochrome50,
    backgroundColor: theme.palette.common.monochrome15,
    border: 'none'
  }
};
